import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Navbar as BSNavbar, Nav, Container, Button } from 'react-bootstrap';

function Navbar({ user, onLogout, unreadCount = 0 }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const currentPath = location.pathname;

  // Hide top/bottom navbar on individual chat screens so it behaves like a clean, full-screen mobile chat
  const isIndividualChat = currentPath.startsWith('/messages/') && currentPath !== '/messages';
  if (isIndividualChat) {
    return null;
  }

  return (
    <>
      {/* TOP BAR: User Name + Logout */}
      <BSNavbar
        bg="dark"
        variant="dark"
        className="py-2 border-bottom border-light fixed-top"
      >
        <Container
          fluid
          className="d-flex justify-content-end align-items-center px-3"
        >
          <BSNavbar.Text
            className="text-light me-3"
            style={{ fontSize: "0.9rem" }}
          >
            <i className="fas fa-user-circle me-1"></i>
            {user.name}
          </BSNavbar.Text>
          <Button variant="outline-light" size="sm" onClick={handleLogout} title="Logout">
            <i className="fas fa-sign-out-alt"></i>
          </Button>
        </Container>
      </BSNavbar>

      {/* BOTTOM BAR: 5-Tab Navigation with Badges */}
      <BSNavbar
        bg="dark"
        variant="dark"
        fixed="bottom"
        className="py-0 border-top border-light"
        style={{ height: "60px", zIndex: 1030 }}
      >
        <Container fluid className="d-flex align-items-center h-100 px-1">
          <Nav className="d-flex flex-row flex-grow-1 justify-content-around w-100">
            {/* 1. Dashboard */}
            <Nav.Link
              as={Link}
              to="/dashboard"
              className={`d-flex flex-column align-items-center px-2 ${
                currentPath === "/dashboard" ? "text-success" : "text-light"
              }`}
              style={{ fontSize: "0.75rem", minWidth: "55px" }}
            >
              <i className="fas fa-home" style={{ fontSize: "18px" }}></i>
              <span className="mt-1">Dashboard</span>
            </Nav.Link>

            {/* 2. Calls (Consolidated Dial + History) */}
            <Nav.Link
              as={Link}
              to="/calls"
              className={`d-flex flex-column align-items-center px-2 ${
                currentPath === "/calls" || currentPath === "/make-call"
                  ? "text-success"
                  : "text-light"
              }`}
              style={{ fontSize: "0.75rem", minWidth: "55px" }}
            >
              <i className="fas fa-phone" style={{ fontSize: "18px" }}></i>
              <span className="mt-1">Calls</span>
            </Nav.Link>

            {/* 3. Messages (New In-App Chat with Unread Badge) */}
            <Nav.Link
              as={Link}
              to="/messages"
              className={`d-flex flex-column align-items-center px-2 position-relative ${
                currentPath.startsWith("/messages")
                  ? "text-success"
                  : "text-light"
              }`}
              style={{ fontSize: "0.75rem", minWidth: "55px" }}
            >
              <div className="position-relative">
                <i className="fas fa-comment-dots" style={{ fontSize: "19px" }}></i>
                {unreadCount > 0 && (
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{ fontSize: "0.65rem", padding: "0.2em 0.45em" }}
                  >
                    {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
                )}
              </div>
              <span className="mt-1">Messages</span>
            </Nav.Link>

            {/* 4. Contacts (Consolidated All Contacts + Whitelist + Blacklist) */}
            <Nav.Link
              as={Link}
              to="/contacts"
              className={`d-flex flex-column align-items-center px-2 ${
                currentPath === "/contacts" ||
                currentPath === "/whitelist" ||
                currentPath === "/blacklist"
                  ? "text-success"
                  : "text-light"
              }`}
              style={{ fontSize: "0.75rem", minWidth: "55px" }}
            >
              <i className="far fa-address-book" style={{ fontSize: "18px" }}></i>
              <span className="mt-1">Contacts</span>
            </Nav.Link>

            {/* 5. Settings */}
            <Nav.Link
              as={Link}
              to="/settings"
              className={`d-flex flex-column align-items-center px-2 ${
                currentPath === "/settings" ? "text-success" : "text-light"
              }`}
              style={{ fontSize: "0.75rem", minWidth: "55px" }}
            >
              <i className="fas fa-cog" style={{ fontSize: "18px" }}></i>
              <span className="mt-1">Settings</span>
            </Nav.Link>
          </Nav>
        </Container>
      </BSNavbar>
    </>
  );
}

export default Navbar;